import React from "react";
import { LoadingPill } from "./LoadingLine.styled";

const LoadingLine = ({ minWidth, maxWidth, exactWidth = null }) => (
  <LoadingPill
    width={
      exactWidth || Math.floor(Math.random() * (maxWidth - minWidth + 1)) + minWidth
    }
  />
);

export default LoadingLine;
